import { headerBlocks } from "./receipt-template.js";
const rowBlocks = (row, columns, prefix) => {
    const [main = '—', ...rest] = row.values;
    const blocks = [
        { kind: 'pair', label: `${prefix}${row.label}`, value: main },
    ];
    const details = rest
        .map((value, index) => {
        const column = columns[index + 1];
        return column === undefined ? null : `${column.label}: ${value}`;
    })
        .filter((text) => text !== null);
    if (details.length > 0) {
        blocks.push({ kind: 'text', text: `   ${details.join(' · ')}` });
    }
    return blocks;
};
export const reportPrintFor = (input) => {
    const blocks = headerBlocks({
        company: input.company,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, {
        kind: 'text',
        text: input.title.toUpperCase(),
        align: 'center',
        bold: true,
    }, { kind: 'rule' });
    for (const filter of input.filters) {
        blocks.push({ kind: 'pair', label: filter.label, value: filter.value });
    }
    blocks.push({ kind: 'rule' });
    for (const note of input.notes ?? []) {
        blocks.push({ kind: 'text', text: note });
    }
    if ((input.notes ?? []).length > 0)
        blocks.push({ kind: 'rule' });
    if (input.rows.length === 0) {
        blocks.push({
            kind: 'text',
            text: 'Nada neste período.',
            align: 'center',
        });
    }
    input.rows.forEach((row, index) => {
        blocks.push(...rowBlocks(row, input.columns, `${String(index + 1)}. `));
    });
    blocks.push({ kind: 'rule' });
    if (input.others !== null) {
        blocks.push(...rowBlocks(input.others, input.columns, ''));
    }
    blocks.push(...rowBlocks(input.total, input.columns, ''));
    blocks.push({ kind: 'feed', lines: 2 }, { kind: 'cut' });
    return { kind: 'report', title: input.title, blocks };
};
//# sourceMappingURL=report.js.map